import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  addSpeedLearnMapAsync,
  getAllSpeedLearnMapAsync,
  getSpeedLearnMapByIdAsync,
  updateSpeedLearnMapAsync,
  deleteSpeedLearnMapAsync,
  topicsByGoalIdAsync,
} from "./speedlearnmap.async";

const initialState = {
  speedLearnMapLoader: false,
  addSpeedLearnMap: [],
  getAllSpeedLearnMap: [],
  getSpeedLearnMapById: [],
  updateSpeedLearnMap: [],
  speedLearnMapDelete: [],
  topicByGoalId: [],
};

export const speedLearnMapSlice = createSlice({
  name: "speedLearn",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        getAllSpeedLearnMapAsync.pending,
        addSpeedLearnMapAsync.pending,
        getSpeedLearnMapByIdAsync.pending,
        updateSpeedLearnMapAsync.pending,
        deleteSpeedLearnMapAsync.pending,
        topicsByGoalIdAsync.pending
      ),
      (state) => {
        state.speedLearnMapLoader = true;
      }
    );

    builder.addMatcher(
      isAnyOf(getAllSpeedLearnMapAsync.fulfilled),
      (state, action) => {
        state.speedLearnMapLoader = false;
        state.getAllSpeedLearnMap = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(addSpeedLearnMapAsync.fulfilled),
      (state, action) => {
        state.speedLearnMapLoader = false;
        state.addSpeedLearnMap = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(getSpeedLearnMapByIdAsync.fulfilled),
      (state, action) => {
        state.speedLearnMapLoader = false;
        state.getSpeedLearnMapById = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(deleteSpeedLearnMapAsync.fulfilled),
      (state, action) => {
        state.speedLearnMapLoader = false;
        state.speedLearnMapDelete = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(updateSpeedLearnMapAsync.fulfilled),
      (state, action) => {
        state.speedLearnMapLoader = false;
        state.updateSpeedLearnMap = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(topicsByGoalIdAsync.fulfilled),
      (state, action) => {
        state.speedLearnMapLoader = false;
        state.topicByGoalId = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getAllSpeedLearnMapAsync.rejected,
        addSpeedLearnMapAsync.rejected,
        getSpeedLearnMapByIdAsync.rejected,
        updateSpeedLearnMapAsync.rejected,
        deleteSpeedLearnMapAsync.rejected,
        topicsByGoalIdAsync.rejected
      ),
      (state, action) => {
        state.speedLearnMapLoader = false;
      }
    );
  },
  reducers: {
    emptySpeedLearnMap: (state) => initialState,
  },
});

export const { emptySpeedLearnMap } = speedLearnMapSlice.actions;

export default speedLearnMapSlice.reducer;
